import { CHECK_RESULT_DISPLAY, type CheckResultDisplay } from './checkResult';

import { StatusBadge } from '../StatusBadge/StatusBadge';

export const CheckResultBadge = ({
  result,
}: {
  result: CheckResultDisplay;
}) => {
  const { tone, label } = CHECK_RESULT_DISPLAY[result];
  return <StatusBadge tone={tone}>{label}</StatusBadge>;
};
